export const getImageUrl = (url) => {
  if (!url) return "/images/placeholder-property.jpg";

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  const storageBase = (process.env.REACT_APP_STORAGE_URL || "").replace(
    /\/+$/,
    "",
  );
  const cleanPath = url.replace(/^\/?storage\//, "").replace(/^\/+/, "");

  if (!storageBase) {
    return `/storage/${cleanPath}`;
  }

  return `${storageBase}/storage/${cleanPath}`;
};
